
import wrapperImplementation from "gameiom/wrapper/wrapper-implementation";
import GameState from "slotworks/model/game-state";
import gameState from "slotworks/model/game-state";
import GameOver from "slotworks/state-machine/standard/states/game-over";

export default class GameiomGameOver extends GameOver {
    public complete() {
        wrapperImplementation.onResume.addOnce(() => super.complete());
        gameWrapper.balancesUpdate(
            GameState.getCurrentGame().realBalance,
            GameState.getCurrentGame().freeBalance
        );
        if (!gameState.getCurrentGame().areFreespinsPending()) {
            gameWrapper.disableFeatureMode();
        }
        gameWrapper.setIdle();
    }
}
